<template>
	<!-- 支付跳自己写的收银台 -->
	<div class="paymentBox" id="paymentBox" ref="paymentBox" :class="!isMobile ? 'pcbox' : ''">
		<div class="payBox">
			<div class="titleTxt">
				<van-image
				  width="26"
				  height="26"
				  :src="require('@/assets/images/common/gm_icon.png')"
				/>
				<span style="margin-left: 10px;">GM STORE</span>
			</div>
			<p class="discountTips">{{ $t('pay.maxDiscountTips') }}</p>
			<div class="payForm" style="height: calc(100% - 10rem);overflow-y:scroll;">
				<van-cell-group>
				  <van-field key="orderMoney"
				      v-model="orderMoney"
				      :label="$t('pay.goodMoney')"
					  input-align="right"
					  readonly
				    >
						<template #button>
						  <span>{{moneyUnit}}</span>
						</template>
				  </van-field>
				  <van-field key="payAllCoupon" v-if="couponList.length > 0"
				      v-model="payAllCoupon"
				      :label="$t('pay.discountCoupon')"
					  :left-icon="payAllCoupon < 0 ? seledIcon : selIcon"
					  input-align="right"
					  readonly
					  class="discount"
					  @click-left-icon="handleCouponChecked"
					  @click-input="handleOpenCoupon(false)"
				    >
						<template #button>
							<div class="flexc" @click="handleOpenCoupon(false)">
								{{ $t('pay.detail') }}<van-icon name="arrow" />
							</div>
						</template>
				  </van-field>
				  <van-field key="payAllGMcoin" label-width="12em" v-if="allGMCoin > 0"
				      v-model="payAllGMcoin"
				      :label="$t('pay.gmCoin')+'(50%)'"
					  :left-icon="payAllGMcoin < 0 ? seledIcon : selIcon"
					  input-align="right"
					  readonly
					  class="discount"
					  @click-left-icon="handleGMcoinChecked"
					  @click-input="handleOpenGMcoin(false)"
				    >
						<template #button>
							<div class="flexc" @click="handleOpenGMcoin(false)">
								{{ $t('pay.detail') }}<van-icon name="arrow" />
							</div>
					    </template>
				  </van-field>
				  <van-field key="payAllPayGMcoin" label-width="12em" v-if="allPayGMCoin > 0"
				      v-model="payAllPayGMcoin"
				      :label="$t('pay.paygmCoin')+'(100%)'"
				  					  :left-icon="payAllPayGMcoin < 0 ? seledIcon : selIcon"
				  					  input-align="right"
				  					  readonly
				  					  class="discount"
				  					  @click-left-icon="handlePayGMcoinChecked"
				  					  @click-input="handleOpenPayGMcoin(false)"
				    >
				  						<template #button>
				  							<div class="flexc" @click="handleOpenPayGMcoin(false)">
				  								{{ $t('pay.detail') }}<van-icon name="arrow" />
				  							</div>
				  					    </template>
				  </van-field>
				</van-cell-group>
				<p v-if="(!isMultiple && allGMCoin > 0) || (!isMultiple && allPayGMCoin > 0)" class="discountUseTips">{{ $t('pay.payTypeTips') }}</p>
				<!-- <p v-if="!isMultiple && allGMCoin > 0" class="discountUseTips">GM코인은 첫 결제 시 100%까지 차감 가능하며, 이후에는 50%까지 차감 가능합니다.</p> -->
			</div>
			<div class="payResult">
				<div class="moneyBox">
					<p class="total">{{ $t('pay.total') }}：<b>{{ parseInt(orderMoney) + parseInt(payAllCoupon) + parseInt(payAllGMcoin) + parseInt(payAllPayGMcoin) }}</b></p>
					<p class="discount" v-if="payAllCoupon || payAllGMcoin || payAllPayGMcoin">{{ $t('pay.discountMoney') }}：{{ parseInt(payAllCoupon) + parseInt(payAllGMcoin) + parseInt(payAllPayGMcoin) }}</p>
					<div class="payTypeTip" v-if="nowPayTypeValue == 'default'" @click="showPayType">
						<van-icon name="question-o" />
						결제수단
					</div>
				</div>
				<div class="btnBoxs">
					<!-- <div class="btnBox" @click.stop="handlePayCancel">
						{{ $t('common.cancel') }}
					</div> -->
					<van-button class="btnBox h30" block @click.stop="handlePayCancel">{{ $t('common.cancel') }}</van-button>
					<van-button class="btnBox h30 active" block :loading="payLoading" v-if="nowPayTypeValue == 'default'" @click.stop="handlePay">{{ $t('pay.paybtn') }}</van-button>
					<van-button class="btnBox h30 active" block v-else @click.stop="handlePay">{{ 'ENJOY 지불' }}</van-button>
					<!-- <div class="btnBox active" v-if="nowPayTypeValue == 'default'" @click.stop="handlePay">
						{{ $t('pay.paybtn') }}
					</div> -->
					<!-- <div style="width: 50%;" class="btnBox active" v-else @click.stop="handlePay">
						{{ 'ENJOY 지불' }}
					</div> -->
				</div>
			</div>
			
		</div>
		
		<!-- 代金券详情 -->
		<!-- <Teleport to="#app"> -->
		<van-popup
		  v-model:show="showCouponList"
		  round
		  closeable
		  position="bottom"
		  :style="{ height: '45%' }"
		  :close-on-click-overlay="false"
		  @click-close-icon="handleConfirmCoupon"
		>
		<div class="couponBox" style="padding: 0;">
			<div class="couponTitle">{{ $t('pay.discountTitle') }}</div>
			<div class="couponList">
				<ul>
					<!-- effective 0不可用，1可用 -->
					<li v-for="(item,index) in couponList" :key="index">
						<div class="van-coupon" @click="handleCouponCheck(item)" :class="{'active':item.checked,'disabled':item.effective == 0}">
							<div class="van-coupon__content">
								<div class="van-coupon__body" style="padding-left: 1rem;padding-right: 3.125rem;">
									<p class="van-coupon__name">
									{{ $t('pay.expTime') }}：{{ parseTime(item.endTime,'{y}-{m}-{d}') }}
										<span class="redNum big">{{ $t('common.mUnit') }}{{ formatNumstr(formatCouponTypeStr(item,'money')) }}</span>
									</p>
									<p class="van-coupon__valid">
										<span v-if="item.type == 1 || item.type == 0">{{ formatCouponTypeStr(item,'desc') }}</span>
										<span v-else-if="item.type == 2 && item.gameId != 0">{{ $t('pay.onlyForthisGame') }}</span>
										<span class="redNum">{{ formatCouponTypeStr(item,'type') }}</span>
									</p>
									
									<van-checkbox class="van-coupon__corner" v-model="item.checked" :disabled="item.effective == 0 ? true : false"></van-checkbox>
									<!-- <span class="nums">{{ $t('pay.remainNums',{ num: 1 }) }}</span> -->
								</div>
								
							</div>
						</div>
					</li>
				</ul>
			</div>
			<div class="van-coupon-list__bottom" style="position: fixed;">
				<van-button block round plain type="primary" @click="handleCancelCoupon">{{ $t('pay.noUseDiscount') }}</van-button>
			</div>
		</div>
		</van-popup>
		<!-- </Teleport> -->
		
		<!-- GM币详情 -->
		<van-popup
		  v-model:show="showGMCoin"
		  round
		  closeable
		  position="bottom"
		  :style="{ height: vh }"
		  :close-on-click-overlay="false"
		>
		<div class="couponBox" style="padding: 0;">
			<div class="couponTitle">{{ $t('pay.gmCoinTitle') }}</div>
			<div class="gmForm">
				<van-cell-group :title="$t('pay.gmCoinTips')">
				  <van-field key="allGMCoin" label-width="10em"
				      v-model="allGMCoin"
				      :label="$t('pay.allGMCoin')"
					  input-align="right"
					  readonly
				    >
				  </van-field>
				  <van-field key="payAllGMcoin" label-width="10em"
				      v-model="inputAllGMcoin"
				      :label="$t('pay.useGMCoin')"
					  type="digit"
					  input-align="right"
					  error
					  :placeholder="$t('pay.gmCoinPlaceholder')"
					  @update:model-value="handleInputGMcoin"
					  @focus="handleH('100%')"
					  @blur="handleH('45%')"
				    >
				  </van-field>
				  <van-field key="remainGMCoin" label-width="10em"
				      v-model="remainGMCoin"
				      :label="$t('pay.remainGMCoin')"
					  input-align="right"
					  readonly
				    >
				  </van-field>
				</van-cell-group>
				
			</div>
			<div class="van-coupon-list__bottom btnBoxs s" style="padding-bottom: 0.3125rem;position: fixed;">
				<div class="btnBox" @click.stop="goSuperMall">
					{{ $t('pay.freeGetGM') }}
				</div>
				<div class="btnBox active" @click.stop="handleConfirmGM">
					{{ $t('common.confirm') }}
				</div>
			</div>
		</div>
		</van-popup>
		
		<!-- 全额GM币详情 -->
		<van-popup
		  v-model:show="showPayGMCoin"
		  round
		  closeable
		  position="bottom"
		  :style="{ height: vh }"
		  :close-on-click-overlay="false"
		>
		<div class="couponBox" style="padding: 0;">
			<div class="couponTitle">{{ $t('pay.paygmCoinTitle') }}</div>
			<div class="gmForm">
				<van-cell-group :title="$t('pay.paygmCoinTips')">
				  <van-field key="allPayGMCoin" label-width="10em"
				      v-model="allPayGMCoin"
				      :label="$t('pay.allPayGMCoin')"
					  input-align="right"
					  readonly
				    >
				  </van-field>
				  <van-field key="payAllPayGMcoin" label-width="10em"
				      v-model="inputAllPayGMcoin"
				      :label="$t('pay.usePayGMCoin')"
					  type="digit"
					  input-align="right"
					  error
					  :disabled="isPayGMcoinDisabled"
					  :placeholder="$t('pay.paygmCoinPlaceholder')"
					  @update:model-value="handleInputPayGMcoin"
					  @focus="handleH('100%')"
					  @blur="handleH('45%')"
				    >
				  </van-field>
				  <van-field key="remainPayGMCoin" label-width="10em"
				      v-model="remainPayGMCoin"
				      :label="$t('pay.remainPayGMCoin')"
					  input-align="right"
					  readonly
				    >
				  </van-field>
				</van-cell-group>
				
			</div>
			<div class="van-coupon-list__bottom btnBoxs s" style="padding-bottom: 0.3125rem;position: fixed;">
				<div class="btnBox" @click.stop="goRecharge">
					{{ $t('pay.gorecharge') }}
				</div>
				<div class="btnBox active" @click.stop="handleConfirmPayGM">
					{{ $t('common.confirm') }}
				</div>
			</div>
		</div>
		</van-popup>
		
		<!-- ENJOY支付方式 -->
		<van-popup :style="{ height: '80%' }" v-model:show="showPayTypeSelect" round position="bottom">
		  <van-picker
			:title="$t('pay.selectPayTitle')"
		    :columns="payTypeSelectList"
		    @cancel="showPayTypeSelect = false"
		    @confirm="onConfirm"
			:confirm-button-text="$t('common.confirm')"
			:cancel-button-text="$t('common.cancel')"
		  />
		</van-popup>
		
		<van-popup
		  v-model:show="isShowPayType"
		  round
		  closeable
		  style="top:-55%;width: 90%;height: 90%;position: relative;overflow: auto;"
		  :close-on-click-overlay="false"
		  @click-close-icon="handlePayTypeCancel"
		>
		<div class="payBox payTypeBox">
			<div class="titleTxt">결제수단</div>
			<div style="position: relative;">
				<typeTable></typeTable>
			</div>
		</div>
		</van-popup>
		
	</div>
</template>

<script setup>
	import { getCurrentInstance,onMounted,onBeforeMount,ref,watch,computed, reactive } from 'vue'
	import useUserStore from '@/store/modules/user'
	import useConfigStore from '@/store/modules/config'
	import typeTable from '@/view/game/typeTable.vue'
	import { orderPay, getUserCoupon,getUserCoinInfo,getHgPayTypeInfo,orderEnjoy,orderMypay,platCoinFirst } from "@/api/payment";
	import { showConfirmDialog,showDialog } from 'vant';
	
	const { proxy } = getCurrentInstance();
	const paymentBox = ref(null)
	const moneyUnit = ref('₩')
	const orderMoney = ref(0)
	const allGMCoin = ref(0)//用户gm币(半价)
	const allPayGMCoin = ref(0)//用户gm币(全价)
	const remainGMCoin = ref(0)
	const remainPayGMCoin = ref(0)
	const payAllGMcoin = ref(0)//选中gm币(半价)
	const payAllPayGMcoin = ref(0)//选中gm币(全价)
	const payAllCoupon = ref(0)//选中抵扣券金额
	const payAllCouponId = ref(0)//选中抵扣券Id
	const payCouponType = ref(0)//选中抵扣券类型
	const inputAllGMcoin = ref(null)//输入gm币
	const inputAllPayGMcoin = ref(null)//输入gm币
	const inputMaxGMcoin = ref(0)//输入限制最大gm币
	const inputMaxPayGMcoin = ref(0)//输入限制最大gm币
	const isMultiple = ref(false)//是否叠加使用
	const showCouponList = ref(false)
	const showGMCoin = ref(false)
	const showPayGMCoin = ref(false)
	const payLoading = ref(false)
	const isShowPayType = ref(false)
	const showPayTypeSelect = ref(false)
	const isFirstGm = ref(0)//是否第一次实用GM币支付（12.26改逻辑无用，之前的默认只能抵扣50%）
	const mulNums = ref(10)//输入的gm币限制10的倍数
	const vh = ref('45%')
	const isPayGMcoinDisabled = ref(false)//全额GM币输入框是否禁用
	// const orderInfo = ref({})
	const payUrl = ref('')
	const payTypeSelectList = ref([
		{text:'기본 결제',value:'default'}
	])
	const nowPayTypeText = ref('기본 결제')
	const nowPayTypeValue = ref('default')
	const couponList = ref([])
	
	const isMobile = computed(() => {
		return useConfigStore().isMobile
	})
	const userSign = computed(() => {
		return useUserStore().userSign
	})
	const roleInfo = computed(() => {
		return useUserStore().roleInfo
	})
	const orderInfo = computed(() => {
		return useUserStore().orderInfo
	})
	const selIcon = ref(require('@/assets/images/common/circle.svg'))
	const seledIcon = ref(require('@/assets/images/common/check-circle.svg'))
	onMounted(() => {
		var width = paymentBox.value.clientWidth
		var height = paymentBox.value.clientHeight
		console.log('宽======',width)
		console.log('高======',height)
	})
	const formatCouponTypeStr = (row,str) => {
		let typeStr = '',moneyStr = '',descStr = '',discount = '';
		switch(row.type){
			case 0://全额
				typeStr = proxy.$t('pay.percentDiscount')
				moneyStr = row.num
				if(row.num > orderMoney.value){
					descStr = discount = orderMoney.value
				}else{
					descStr = discount = row.num
				}
				descStr = proxy.$t('pay.payMaxLimit',{ num: descStr })
				break;
			case 1://半价
				typeStr = proxy.$t('pay.halfPercentDiscount')
				moneyStr = row.num
				if(row.num > orderMoney.value / 2){
					descStr = discount = orderMoney.value / 2
				}else{
					descStr = discount = row.num
				}
				descStr = proxy.$t('pay.payMaxLimit',{ num: descStr })
				break;
			case 2://满减
				typeStr = proxy.$t('pay.fullReduction',{ num: row.doorsill })//'满'+row.doorsill+'减'+row.derate
				moneyStr = discount = row.derate
				break;
			default:
				break;
		}
		if(str == 'type'){
			return typeStr
		}else if(str == 'money'){
			return moneyStr
		}else if(str == 'desc'){
			return descStr
		}else if(str == 'discount'){
			return discount
		}
	}
	
	const getCoupons = () => {
		getUserCoupon({ money: orderMoney.value }).then((res) => {
			isMultiple.value = res.msg == '1' ? true : false
			// isMultiple.value = true//测试叠加使用方式
			let couponArr = res.data.sort((a,b) => {
				if(a.type == b.type){
					return b.derate - a.derate
				}else{
					return a.type - b.type
				}
			}) || []
			let effectArr = couponArr.filter((item) => item.effective == 1)
			let noeffectArr = couponArr.filter((item) => item.effective == 0)
			couponList.value = effectArr.concat(noeffectArr)
			getAutoDiscount()
			getGMcoins()
		})
	}
	const getGMcoins = () => {
		getUserCoinInfo({}).then((res) => {
			allGMCoin.value = res.data.coin || 0
			allPayGMCoin.value = res.data.payCoupon || 0
			// payCoupon
		})
	}
	// 取最优惠抵扣券金额
	const getAutoDiscount = (isEasy = false) => {
		if(couponList.value.length == 0){
			return false
		}
		let newCoupons = couponList.value.map((item) => {
			item.discount = formatCouponTypeStr(item,'discount')
			if(item.effective == 1){
				return item
			}
		})
		let maxCoupon = newCoupons.sort((a,b) => b.discount - a.discount)[0]
		if(maxCoupon && maxCoupon.id){
			couponCheckd(maxCoupon,isEasy)
		}
	}
	const couponCheckd = (row,isEasy = false) => {
		couponList.value.forEach((item) => {
			if(item.id == row.id){
				item.checked = true
				payAllCoupon.value = -formatCouponTypeStr(item,'discount')
				payAllCouponId.value = item.id
				payCouponType.value = item.type
				if(isEasy){
					handleCouponCheck(item)
				}
			}else{
				item.checked = false
			}
		})
	}
	// 一键选择抵扣券
	const handleCouponChecked = () => {
		handleOpenCoupon(true)
	} 
	// 一键选择gm币
	const handleGMcoinChecked = () => {
		handleOpenGMcoin(true)
	}
	const payGmCoinNotEnough = () => {
		// showDialog({
		//   confirmButtonText: proxy.$t('common.confirm'),
		//   message: '전액 할인 GM 코인’부족하여 GM 으로 이동하여 충전하세요',
		// }).then(() => {
		//   console.log('close')
		// });
		showConfirmDialog({
		  confirmButtonText: proxy.$t('pay.gorecharge'),
		  cancelButtonText: proxy.$t('common.cancel'),
		  message:
		    '전액 할인 GM 코인’부족하여 GM 으로 이동하여 충전하세요',
		})
		  .then(() => {
		    // on confirm
			goRecharge()
		  })
		  .catch(() => {
		    // on cancel
			console.log('cancel')
		  });
	}
	// 一键选择全额gm币
	const handlePayGMcoinChecked = () => {
		if(Number(orderMoney.value) > Number(allPayGMCoin.value)){
			payGmCoinNotEnough()
		}else{
			handleOpenPayGMcoin(true)
		}
	}
	const handleCouponCheck = (row) => {
		if(row.effective == 0){
			return false
		}
		couponCheckd(row)
		showCouponList.value = false
		handleCancelGM()
		handleCancelPayGM() // 取消全额GM币
		if(!isMultiple.value){
			proxy.$toast(proxy.$t('pay.payTypeTips'))
		}
	}
	const handleConfirmCoupon = () => {
		showCouponList.value = false
		handleCancelGM()
		handleCancelPayGM() // 取消全额GM币
	}
	const handleCancelCoupon = () => {
		payAllCoupon.value = 0
		payAllCouponId.value = 0
		payCouponType.value = 0
		showCouponList.value = false
		couponList.value.forEach((item) => {
			item.checked = false
		})
	}
	const handleCancelGM = () => {
		payAllGMcoin.value = 0
		remainGMCoin.value = 0
		inputAllGMcoin.value = null
		showGMCoin.value = false
	}
	const handleCancelPayGM = () => {
		payAllPayGMcoin.value = 0
		remainPayGMCoin.value = 0
		inputAllPayGMcoin.value = null
		isPayGMcoinDisabled.value = false
		showPayGMCoin.value = false
	}
	const handleConfirmGM = () => {
		if(!isMultiple.value){//不能叠加
			if(inputAllGMcoin.value%mulNums.value != 0){
				proxy.$toast(proxy.$t('pay.gmCoinPlaceholder',{ num: mulNums.value }))
				return false
			}
			if(inputAllGMcoin.value > 0){
				handleCancelCoupon()
				handleCancelPayGM()
			}
		}else{
			let needPayMoney = parseInt(orderMoney.value) + parseInt(payAllCoupon.value) - inputAllGMcoin.value - inputAllPayGMcoin.value
			if(needPayMoney%mulNums.value != 0){
				proxy.$toast(proxy.$t('pay.needPayTips',{ num: mulNums.value }))
				return false
			}
		}
		if(inputAllGMcoin.value > 0 && !isMultiple.value){
			proxy.$toast(proxy.$t('pay.payTypeTips'))
		}
		payAllGMcoin.value = -inputAllGMcoin.value
		showGMCoin.value = false
	}
	const handleConfirmPayGM = () => {
		if(!isMultiple.value){//不能叠加
			if(inputAllPayGMcoin.value%mulNums.value != 0){
				proxy.$toast(proxy.$t('pay.gmCoinPlaceholder',{ num: mulNums.value }))
				return false
			}
			if(inputAllPayGMcoin.value > 0){
				handleCancelCoupon()
				handleCancelGM()
			}
		}else{
			let needPayMoney = parseInt(orderMoney.value) + parseInt(payAllCoupon.value) - inputAllGMcoin.value - inputAllPayGMcoin.value
			if(needPayMoney%mulNums.value != 0){
				proxy.$toast(proxy.$t('pay.needPayTips',{ num: mulNums.value }))
				return false
			}
		}
		if(inputAllPayGMcoin.value > 0 && !isMultiple.value){
			proxy.$toast(proxy.$t('pay.payTypeTips'))
		}
		payAllPayGMcoin.value = -inputAllPayGMcoin.value
		isPayGMcoinDisabled.value = false
		showPayGMCoin.value = false
	}
	const onConfirm = ({ selectedOptions }) =>{
		nowPayTypeText.value = selectedOptions[0].text
		nowPayTypeValue.value = selectedOptions[0].value
		showPayTypeSelect.value = false
		console.log(nowPayTypeValue.value);
	}
	const goRecharge = () => {
		handleCancelPayGM()
		proxy.commonPostMsg({ action: 'webPayAction', data: 'https://www.gm321321.com/personal' })
		// proxy.commonPostMsg({ action: 'gotoGM', data: 9, params: proxy.$Base64.encode(params)})
	}
	const goSuperMall = () => {
		handleCancelGM()
		let params = JSON.stringify({ type: 2})//道具商城子栏目type:2跳gm币签到页，栏目9奇葩商城页
		proxy.commonPostMsg({ action: 'gotoGM', data: 9, params: proxy.$Base64.encode(params)})
	}
	const handleOpenCoupon = (isEasy = false) => {
		if(!isEasy){
			showCouponList.value = true
		}
		getAutoDiscount(isEasy)
	}
	const handleOpenGMcoin = (isEasy = false) => {
		if(isMultiple.value){//能叠加
			inputMaxGMcoin.value = parseInt(orderMoney.value) + parseInt(payAllCoupon.value)
		}else{
			inputMaxGMcoin.value = parseInt(orderMoney.value)
		}
		//增加gm币使用条件，首次可使用100%，后续每次最多使用订单金额50%
		if(isFirstGm.value != 1){
			inputMaxGMcoin.value = parseInt(inputMaxGMcoin.value / 2)
		}
		if(inputMaxGMcoin.value >= mulNums.value){
			if(!inputAllGMcoin.value){
				let maxInput = Math.min(allGMCoin.value,inputMaxGMcoin.value)
				inputAllGMcoin.value = Math.floor(maxInput/mulNums.value) * mulNums.value
				remainGMCoin.value = allGMCoin.value - inputAllGMcoin.value
			}
			if(!isEasy){
				showGMCoin.value = true
			}else{
				handleConfirmGM()
			}
		}else{
			proxy.$toast(proxy.$t('pay.payLimitTips'))
		}
	}
	const handleOpenPayGMcoin = (isEasy = false) => {
		console.log('订单金额====',orderMoney.value)
		console.log('全额币金额====',allPayGMCoin.value)
		if(Number(orderMoney.value) > Number(allPayGMCoin.value)){
			payGmCoinNotEnough()
			return false;
		}
		inputMaxPayGMcoin.value = parseInt(orderMoney.value)

		if(inputMaxPayGMcoin.value >= mulNums.value){
			if(!inputAllPayGMcoin.value){
				let maxInput = Math.min(allPayGMCoin.value,inputMaxPayGMcoin.value)
				inputAllPayGMcoin.value = Math.floor(maxInput/mulNums.value) * mulNums.value
				remainPayGMCoin.value = allPayGMCoin.value - inputAllPayGMcoin.value
			}
			
			// 当全额GM币大于或等于订单金额且一键选择时，自动填入全额并禁用输入
			if(Number(allPayGMCoin.value) >= Number(orderMoney.value)){
				inputAllPayGMcoin.value = parseInt(orderMoney.value)
				remainPayGMCoin.value = allPayGMCoin.value - parseInt(orderMoney.value)
				isPayGMcoinDisabled.value = true
			}else{
				isPayGMcoinDisabled.value = false
			}
			
			if(!isEasy){
				showPayGMCoin.value = true
			}else{
				handleConfirmPayGM()
			}
		}else{
			proxy.$toast(proxy.$t('pay.payLimitTips'))
		}
	}
	const handlePayTypeSelect = () => {
		payTypeSelectList.value = [
			{text:'기본 결제',value:'default'}
		]
		getHgPayTypeInfo().then(res=>{
			console.log(res);
			let list = Object.entries(res.data).map(([key, value]) => {
			    return {
			        text: value,
			        value: key
			    };
			});
			payTypeSelectList.value = payTypeSelectList.value.concat(list)
			showPayTypeSelect.value = true
		})
	}
	const handleInputGMcoin = (val) => {
		let maxInput = Math.min(allGMCoin.value,inputMaxGMcoin.value)
		if(val > maxInput){
			inputAllGMcoin.value = Math.floor(maxInput/mulNums.value) * mulNums.value
		}else{
			inputAllGMcoin.value = Math.floor(val/mulNums.value) * mulNums.value
		}
		remainGMCoin.value = allGMCoin.value - inputAllGMcoin.value
	}
	const handleInputPayGMcoin = (val) => {
		// 如果输入框被禁用，不允许修改
		if(isPayGMcoinDisabled.value){
			return;
		}
		let maxInput = Math.min(allPayGMCoin.value,inputMaxPayGMcoin.value)
		if(val > maxInput){
			inputAllPayGMcoin.value = Math.floor(maxInput/mulNums.value) * mulNums.value
		}else{
			inputAllPayGMcoin.value = Math.floor(val/mulNums.value) * mulNums.value
		}
		remainPayGMCoin.value = allPayGMCoin.value - inputAllPayGMcoin.value
	}
	const handlePay = () => {
		// console.log('支付')
		if(payLoading.value){
			proxy.$toast('Loading...')
			return false
		}
		payLoading.value = true
		let args = {
			orderId: orderInfo.value.orderId,
			totalAmount: orderInfo.value.totalMoney,
			userId: orderInfo.value.SuperUserId,
			goodId: orderInfo.value.goodid,
			gameId: roleInfo.value.gameId,
			goodName: orderInfo.value.goodName,
			num: orderInfo.value.num,
			voucher: 0,
			voucherType: 0
		}
		// 是否选抵扣券
		if(payAllCouponId.value){
			args.voucherId = payAllCouponId.value
			args.voucher = Math.abs(payAllCoupon.value)
			args.voucherType = payCouponType.value
		}
		// 是否使用GM币（12.26改为只能抵扣50%，新加抵扣全部的）
		if(payAllGMcoin.value){
			args.platCoin = Math.abs(payAllGMcoin.value)
		}
		if(payAllPayGMcoin.value){
			args.payCoupon = Math.abs(payAllPayGMcoin.value)
		}
		args.totalAmount = parseInt(orderMoney.value) + parseInt(payAllCoupon.value) + parseInt(payAllGMcoin.value) + parseInt(payAllPayGMcoin.value)
		// console.log(args)
		if(args.totalAmount == 0){
			orderPay(args).then((res) => {
				if(res.data){
					payUrl.value = res.data
					proxy.commonPostMsg({ action: 'webPayAction', data: payUrl.value })
				}else{
					proxy.sdkPay('pay_success',res.msg)
					proxy.$toast(res.msg)
				}
				payLoading.value = false
			}).catch((err) => {
				proxy.sdkPay('pay_fail',err.msg)
				payLoading.value = false
			})
		}else{
			orderMypay(args).then((res) => {
				console.log(res)
				if(res.data){
					payUrl.value = res.data
					proxy.commonPostMsg({ action: 'webPayAction', data: payUrl.value })
				}else{
					proxy.sdkPay('pay_success',res.msg)
					proxy.$toast(res.msg)
				}
				payLoading.value = false
			}).catch((err) => {
				proxy.sdkPay('pay_fail',err.msg)
				payLoading.value = false
			})
		}
		
	}
	const showPayType = () =>{
		isShowPayType.value = true
	}
	const handlePayTypeCancel = () =>{
		isShowPayType.value = false
	}
	const handlePayCancel = () => {
		if(payLoading.value){
			proxy.$toast('Loading...')
			return false
		}
		payAllGMcoin.value = 0
		payAllCoupon.value = 0
		payUrl.value = ''
		proxy.sdkPay('pay_fail','')
	}
	const handleH = (val) => {
		vh.value = val
	}
	watch(userSign, (newVal, oldVal) => {
		if(!newVal){
			proxy.commonPostMsg({ action: 'webDidLoad' })
		}else{
			proxy.commonPostMsg({ action: 'webPayMsgInfo' })
		}
	},{ immediate: true })
	watch(orderInfo, (newVal, oldVal) => {
		if(newVal){
			orderMoney.value = newVal.totalMoney
			getCoupons()
			// platCoinFirst().then((res) => {//无用
			// 	console.log(res)
			// 	if(res && res.data){
			// 		isFirstGm.value = res.data.isFirst || 0
			// 	}
			// })
		}
	},{ immediate: true })
	watch(allGMCoin, (newVal, oldVal) => {
		if(isMultiple.value && newVal > 10){
			inputMaxGMcoin.value = parseInt(orderMoney.value) + parseInt(payAllCoupon.value)
			inputAllGMcoin.value = Math.min(allGMCoin.value,inputMaxGMcoin.value)
			payAllGMcoin.value = -inputAllGMcoin.value
		}
	})
</script>

<style lang="less" scoped>
	.paymentBox{
		padding: 0.625rem 0 0;height: 100vh;box-sizing: border-box;
		/deep/ .van-cell{
			font-size: 1.125rem;
		}
		/deep/ .van-field__label{
			font-weight: 500;
		}
		.btnBoxs{
			display: flex;align-items: center;justify-content: space-between;
			.btnBox{
				display: inline-block;text-align: center;
				font-size: 1.125rem;
				padding: 0.5rem 1.875rem;border-radius: 0.3125rem;width: 42%;
				border: 0.0625rem solid #51BAC0;color: #51BAC0;box-sizing: border-box;
				&.disabled{
					pointer-events: none;cursor: default;
				}
				&.active{
					border: none;
					background: linear-gradient(to right,#51BAC0,#85D6DA);color: #fff;
				}
				&.h30{
					height: 2.25rem;
				}
			}
			&.s{
				.btnBox{
					font-size: 0.875rem;
					padding: 0.3125rem 0;
				}
			}
		}
		.payTypeTip{
			font-size: 0.825rem;position: absolute;bottom: 0;right: 0;
			color: #969799;display: inline-block;z-index: 111;
		}
		.payTypeBox{
			max-width:unset;min-width:unset;
			padding: 0 1rem !important;
		}
		.payBox{
			width: 100%;padding: 0;box-sizing: border-box;height: 100%;position: relative;
			margin: 0 auto;
			p{ margin: 0.625rem 0; }
			.titleTxt{
				margin: 0 0 0.375rem;font-size: 1.25rem;font-weight: 600;
				display: flex;align-items: center;justify-content: center;
			}
			.discountTips{
				margin: 0 var(--van-cell-horizontal-padding) 0.3125rem;
				display: inline-block;background: #f8d6d5;border-radius: 0.375rem;padding: 0.125rem 0.5rem;
				color: #e92d2c;font-size: 0.75rem;
			}
			.discountUseTips{
				margin: var(--van-cell-vertical-padding) var(--van-cell-horizontal-padding) 0;
				font-size: 0.75rem;text-align: right;color: #ccc;
			}
			.discountUseTips + .discountUseTips{
				margin-top: 0;
			}
			.payForm{
				/* 整个滚动条 */
				::-webkit-scrollbar {
				    width: 0.25rem; /* 设置滚动条的宽度 */
				}
				/* 滚动条轨道 */
				::-webkit-scrollbar-track {
				    background: #f1f1f1; /* 设置轨道的背景颜色 */
				}
				/* 滚动条的滑块 */
				::-webkit-scrollbar-thumb {
				    background: #888; /* 设置滑块的背景颜色 */
				}
				/* 滚动条的滑块hover效果 */
				::-webkit-scrollbar-thumb:hover {
				    background: #555; /* 设置滑块hover时的背景颜色 */
				}
				.discount{
					/deep/ input{
						color: #ee0a24;
					}
					/deep/.van-field__left-icon{
						// margin-top: var(--van-padding-base);
						margin-top: 0;
					}
				}
			}
			.payResult{
				padding: 0 var(--van-cell-horizontal-padding) 0.75rem;position: absolute;bottom: 0;left: 0;width: 100%;box-sizing: border-box;
				background: #fff;
				.moneyBox{
					font-size: 1.125rem;font-weight: 400;margin-bottom: 0.375rem;position: relative;
					p{
						margin: 0; 
						&:first-child{
							height: 1.5625rem;
						}
						&:nth-child(2){
							font-size: 0.8125rem;
						}
					}
					.total{
						b{
							font-size: 1.5rem;
						}
					}
					.discount{
						color: #51BAC0;
					}
				}
				
				
			}
		}
		&.pcbox{
			
		}
		/deep/ .van-popup__close-icon--top-right{
			top: 0.3125rem;
		}
		.couponBox{
			width: 100%;height: 100%;
			.couponTitle{
				width: 100%;padding: 0.3125rem 0;text-align: center;font-size: 1rem;font-weight: 600;
			}
			.couponList,.gmForm{
				width: 100%;max-height: 25rem;overflow-y: scroll;margin: 0;
				padding-top: 0.3125rem;padding-bottom: 3.75rem;
			}
			.couponList{
				/deep/.van-coupon{
					background: url('~@/assets/images/common/coupon_bg.png') no-repeat 100%;opacity: 0.35;
					&.active{
						opacity: 1;
					}
					&.disabled{
						filter: grayscale(100%);
					}
				}
				/deep/.van-coupon__content{
					padding: 0.375rem 0 0.5rem;min-height: 3.375rem;
				}
				/deep/.van-coupon__name{
					font-size: 0.875rem;line-height: 1rem;margin-bottom: 0.1875rem;
				}
				/deep/.van-coupon__valid{
					color: #E82D2D;
				}
				.redNum{
					display: inline-block;float: right;color: #E82D2D;
					&.big{
						font-size: 1rem;font-weight: 800;
					}
				}
				.nums{
					position: absolute;right: 0.3125rem;bottom: -0.625rem;
					font-size: 0.625rem;
				}
			}
			/deep/.van-button{
				height: 2rem;
			}
			.gmForm{
				margin-bottom: 1.875rem;padding-top: 0;padding-bottom: 2.625rem;
				/deep/.van-cell-group__title{
					padding: 0 1rem 0.3125rem;font-size: 0.75rem;line-height: 0.875rem;
				}
				/deep/ .van-cell{
					font-size: 0.875rem;
					padding: 0.25rem 1rem;
				}
			}
			.btnItem{
				width: 50%;float: left;padding: 0 0.625rem;box-sizing: border-box;
			}
		}
	}
	
</style>